import i18n from 'modules/core/lib/i18n'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

type TaskTypes = TaskConfigurationTypes & DataCollectionCategories

export const WIZARD_TASK_TITLES = (): Partial<Record<TaskTypes, string>> => {
  return {
    [TaskConfigurationTypes.Single]: i18n.t(
      'processes.process_settings.wizard.tasks.types.single_task.title'
    ),
    [TaskConfigurationTypes.UploadDocument]: i18n.t(
      'processes.process_settings.wizard.tasks.types.upload_document.title'
    ),
    [TaskConfigurationTypes.SignDocuments]: i18n.t(
      'processes.process_settings.wizard.tasks.types.sign_documents.title'
    ),
    [TaskConfigurationTypes.SendDocumentTemplate]: i18n.t(
      'processes.process_settings.wizard.tasks.types.send_document.title'
    ),
    [DataCollectionCategories.bankInformation]: i18n.t(
      'processes.process_settings.wizard.tasks.types.request_bank_account.title'
    ),
    [DataCollectionCategories.identificationNumber]: i18n.t(
      'processes.process_settings.wizard.tasks.types.request_id.title'
    ),
    [DataCollectionCategories.generalInformation]: i18n.t(
      'processes.process_settings.wizard.tasks.types.request_general_information.title'
    ),
    [DataCollectionCategories.employee_questions_cf]: i18n.t(
      'processes.process_settings.wizard.tasks.types.additional_employee_info.title'
    ),
    [DataCollectionCategories.contract_data]: i18n.t(
      'processes.process_settings.wizard.tasks.types.contract_data.title'
    ),
  }
}
